import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { AxiosInstance } from 'axios';

type ManageRolePermissionPayload = {
  roleId: string;
  functionIds: string[];
};

export const privilegeMutations = {
  manageRolePermission: (client: AxiosInstance) => async (body: ManageRolePermissionPayload) => {
    return (await client.post<ApiResponse>('/manage-role-permission', body)).data;
  },
};
